import * as React from 'react';
import { ISelectFilterOption } from '../../shop-ui/components/search-page/interfaces';
import { VariantMap } from 'PyzShopUi/scripts/product-detail-page/interfaces'
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import { HeaderContainer } from '../components/HeaderContainer';

export interface IWithProductFilterProps {
    onSelect: (value: string, filterType: string, disabled: boolean, isSelected: boolean) => void;
    optionList: ISelectFilterOption[];
    variants?: VariantMap;
}

export const withProductFilter = (
    Component: React.FunctionComponent<{ onToggleItem?(value: string, isSelected: boolean): void }>,
    filterType: string,
    filterClass: string,
    heading: string,
    getSelectedValue?: (optionList: ISelectFilterOption[]) => string,
): React.FunctionComponent<IWithProductFilterProps> =>
    (props: IWithProductFilterProps) => {
        const [optionList, setOptionsList] = React.useState([...props.optionList]);
        const { translate } = useTranslationHook();

        const toggleItem = (value: string, isSelected: boolean): void => {
            let disabled = false;
            const newOptionList = optionList.map((entry: ISelectFilterOption) => {
                entry.selected = entry.value === value;
                if (entry.value === value) {
                    disabled = entry.disabled;
                }
                return entry;
            });
            setOptionsList([...newOptionList]);
            props.onSelect(value, filterType, disabled, isSelected);
        }

        return (
            <>
                <HeaderContainer cssClass={filterClass} headingText={translate(heading, { ns: 'article-detail' })} selectedValue={getSelectedValue(props.optionList)}>
                    <Component onToggleItem={toggleItem} {...props} />
                </HeaderContainer>
            </>
        );
    }
